import React, { useEffect } from "react";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { GrFacebookOption, GrFormClose } from "react-icons/gr";
import image from "../../assets/117198146_291785295222774_8427685377497853952_n.jpg";
import Menu from "../Menu/Menu";

const MobileMenu = ({ showMenu, setShowMenu }) => {
  useEffect(() => {
    window.addEventListener("resize", (e) => {
      let getWidth = window.innerWidth;
      if (getWidth >= 1064) {
        setShowMenu(false);
      }
    });
  }, []);

  return (
    <div className="w-80 h-screen sticky top-0 left-0  bg-own-primary  p-4  ">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-end">
          <img
            width={40}
            className="MenuImageLogo bg-clip-content mr-1"
            src={image}
            alt=""
          />
          <span className="font-semibold text-own-gray-white">
            Sohag Hossain Zayan
          </span>
        </div>
        <span className="bg-own-ternary  p-2 rounded-full ">
          <GrFormClose
            onClick={() => setShowMenu(!showMenu)}
            className="text-4xl cursor-pointer text-own-secondary"
          />
        </span>
      </div>
      <p className="mb-6 text-sm text-own-ternary">
        Inbio is a personal portfolio template. <br /> You can customize all.
      </p>
      <hr className=" opacity-40 mb-8 border-gray_dark" />
      <div className="mb-4">
        <Menu menuClass="menuForMobile" />
      </div>
      <div>
        <h4 className="uppercase ml-3 text-own-gray-white text-sm">
          find with me
        </h4>
        <div className="flex ">
          <span className="mr-3  p-3 rounded-md">
            <GrFacebookOption className=" text-xl  cursor-pointer text-sweet_red" />
          </span>
          <span className="mr-3  p-3 rounded-md">
            <FaInstagram className="text-xl cursor-pointer text-sweet_red" />
          </span>
          <span className="mr-3  p-3 rounded-md">
            <FaLinkedinIn className="text-xl cursor-pointer text-sweet_red" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
